import { Segmented as AntSegmented, type SegmentedProps } from 'antd'
import type { SegmentedValue } from 'antd/es/segmented'

export const Segmented = <T extends SegmentedValue>(props: SegmentedProps<T>) => {
  return <AntSegmented {...props} />
}
